import {h, Component} from 'preact';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import Icon from '@components/common/Icon';

/**
 * Available Props
 *
 * as: String = 'button'
 * disabled: Bool = false,
 * primary: Bool
 * secondary: Bool
 * hollow: Bool
 * ghosted: Bool
 * icon: String
 * loading: Bool
 *
 * onClick: Func
 * tabIndex: [Number, String]
 * toggle: Bool
 */

class Button extends Component {

    constructor( props ) {
        super( props );
        this.state = {
            active: false
        };

        this.handleToggle = this.handleToggle.bind( this );
    }

    handleClick = e => {
        const {disabled} = this.props;

        if ( disabled ) {
            e.preventDefault();
            return;
        }

        invoke( this.props, 'onClick', e, this.props );
    };

    handleToggle = ( e ) => {
        e.preventDefault();
        this.setState( prevState => ({active: !prevState.active}) );
    };

    render( {
                as = 'button',
                icon,
                href,
                type,
                primary,
                secondary,
                tertiary,
                hollow,
                ghosted,
                success,
                error,
                info,
                loading,
                fill,
                fillMobile,
                large,
                small,
                disabled = false,
                className,
                onClick,
                children,
                ...props
            } ) {

        let Element = href ? 'a' : as;
        const tagsList = [
            'a',
            'div',
            'button',
            'input'
        ];
        !tagsList.includes( Element ) ? Element = 'button' : null;

        const buttonClassName = cx(
            'button',
            {
                primary,
                secondary,
                tertiary,
                hollow,
                ghosted,
                success,
                error,
                info,
                fill,
                'w-full md:w-auto': fillMobile,
                large,
                small,
                disabled,
                accept: this.state.active,
                processing: loading
            },
            className
        );

        const iconClassName = cx(
            'mr-2',
            {
                'text-md': small,
                'text-lg': !small
            }
        );

        as === 'a' && href === undefined ? console.warn( as + ' is an <a> tag without an href.' ) : null;

        /**
         * onClick={classArr.includes( 'toggle' ) && Element !== 'a' && !loading ?
                    this.handleToggle :
                    onClick}
         */

        return (
            <Element
                {...props}
                href={href}
                type={type}
                className={buttonClassName}
                onClick={this.handleClick}
                disabled={disabled}>
                {icon && <Icon.ui name={icon} center className={iconClassName}/>}
                {children}
            </Element>
        )
    }
}

export default Button;